export default function EnergyPriceImport() {
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">⚡ ENTSO-E Energieprijzen</div>
      <div className="text-[10px] text-[#8899AA] mb-3">Koppel actuele day-ahead energieprijzen via de ENTSO-E Transparency API.</div>
      <div className="bg-[#FFFBEB] border border-[#FDE68A] rounded-lg p-3 text-[10px] text-[#92400E]">
        <div className="font-semibold mb-1">⚠️ Vereisten</div>
        <ul className="list-disc list-inside space-y-0.5">
          <li>Lovable Cloud moet geactiveerd zijn</li>
          <li>Een ENTSO-E API-key</li>
        </ul>
      </div>
      <button disabled className="mt-3 px-4 py-1.5 text-[11px] font-bold rounded-lg bg-[#D9E2EC] text-[#8899AA] cursor-not-allowed">🔌 Configureer (binnenkort)</button>
    </div>
  );
}
